import React from 'react';
import { EmployeeForm } from 'src/components/enterprise/features/Employee/components/Form/EmployeeForm';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { useEmployeeFormSubmit } from 'src/components/enterprise/features/Employee/components/EmployeeFormWrapper/useEmployeeFormSubmit';

export interface EmployeeFormWrapperProps {
  onSubmit: (data: EmployeeFormFields) => Promise<void>;
  defaultValues: EmployeeFormFields;
}

export const EmployeeFormWrapper: React.FC<EmployeeFormWrapperProps> = ({
  onSubmit,
  defaultValues,
}) => {
  const { handleSubmit } = useEmployeeFormSubmit({ onSubmit });

  return <EmployeeForm onSubmit={handleSubmit} defaultValues={defaultValues} />;
};
